"use client";

import dynamic from "next/dynamic";
import { useEffect, useState } from "react";
import { useGlobalEmbedPlayer } from "@/context/global-embed-player-context";

/*
 * The floating embed player (with framer-motion) is mounted once an embed
 * opens; its code is fetched when the browser is idle after load, so it is
 * off the critical path but ready before the first play.
 */
const loadDock = () =>
	import("@/components/global-embed-player/global-embed-player-dock");

const GlobalEmbedPlayerDock = dynamic(
	() => loadDock().then((module) => module.GlobalEmbedPlayerDock),
	{ ssr: false },
);

export function GlobalEmbedPlayerDockLazy() {
	const { payload, isOpen } = useGlobalEmbedPlayer();
	const [needed, setNeeded] = useState(false);

	useEffect(() => {
		if (isOpen && payload) setNeeded(true);
	}, [isOpen, payload]);

	useEffect(() => {
		const prefetch = () => void loadDock();
		if ("requestIdleCallback" in window) {
			const id = window.requestIdleCallback(prefetch, { timeout: 4000 });
			return () => window.cancelIdleCallback(id);
		}
		const id = setTimeout(prefetch, 2000);
		return () => clearTimeout(id);
	}, []);

	return needed ? <GlobalEmbedPlayerDock /> : null;
}
